const breakpoints = ['769px', '1025px', '1200px']

breakpoints.mobile = breakpoints[0]
breakpoints.tablet = breakpoints[1]
breakpoints.desktop = breakpoints[2]

const defaultColors = {
  blueGrey: '#8c9fbf',
  darkGreen: '#589958',
  darkGrey: '#404041',
  faintGrey: '#c7c7c8',
  hoverGrey: '#e4e7e7',
  hoverLightGrey: '#f8f8f8',
  lightGrey: '#d8d9d9',
  lightestGrey: '#ececec',
  mysteryGrey: '#8c8c8e',
  subtleGreen: '#d5e5d5',
  whiteGrey: '#f8f8f8',
  blue: '#02b7e2',
  green: '#43ac6a',
  orange: '#e78d2d',
  purple: '#b69deb',
  red: '#e2001a',
  tan: '#d0c6b1',
  white: '#FFFFFF',
  yellow: '#fff600',
}

export const colors = {
  ...defaultColors,
  backgroundColor: defaultColors.whiteGrey,
  bodyFontColor: defaultColors.darkGrey,
  bodyFontLightColor: defaultColors.mysteryGrey,
  lineColor: defaultColors.lightestGrey,
}

export const fontSizeNames = ['xxsmall', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'xxxlarge']

export const fontSizes = {
  xxsmall: '10px',
  xsmall: '12px',
  small: '14px',
  medium: '16px',
  large: '18px',
  xlarge: '20px',
  xxlarge: '22px',
  xxxlarge: '24px',
}

export const space = {
  small: 4,
  medium: 8,
  large: 16,
  xlarge: 32,
  xxlarge: 64,
}

export const spaceNames = ['small', 'medium', 'large', 'xlarge', 'xxlarge']

export default {
  breakpoints,
  colors,
  fontSizes,
  space,
}
